import { render } from "./rebus.vue?vue&type=template&id=b6bc84c2&scoped=true"
import script from "./rebus.vue?vue&type=script&lang=js"
export * from "./rebus.vue?vue&type=script&lang=js"

import "./rebus.vue?vue&type=style&index=0&id=b6bc84c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6bc84c2"]])

export default __exports__